import { render, staticRenderFns } from "./DocumentOverview.vue?vue&type=template&id=04c2e254&scoped=true"
import script from "./DocumentOverview.vue?vue&type=script&lang=js"
export * from "./DocumentOverview.vue?vue&type=script&lang=js"
import style0 from "./DocumentOverview.vue?vue&type=style&index=0&id=04c2e254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c2e254",
  null
  
)

export default component.exports